<template>
  <div class="end">
    <TopHeader v-if="!webView" @clickMinimize="closeWindow"/>
    <div class="end-layout">
      <div class="end-container">
        <div class="icon-container">
          <img src="@/assets/icons/heart.svg" />
        </div>
        <h1 v-if="!webView">{{ t('end_title') }}</h1>
        <h1 v-if="webView">{{ split1(t('end_title')) }}<span class="alt-color">{{ split2(t('end_title')) }}</span></h1>
        <p class="intro">{{ t('end_messages_intro') }}</p>
        <div class="button-container">
          <ChatButton
            :types="['primary']"
            class="sanitas-button"
            @click="closeWindow"
            :label="t('end_buttons_close')"
          />
          <ChatButton
            :types="['secondary']"
            class="sanitas-button"
            @click="restartChat"
            :label="t('end_buttons_restart')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatButton from './ChatButton'
import TopHeader from './TopHeader'
import { mapGetters } from 'vuex'
import { trigger, triggerType } from '@/helpers/Tracker'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { EVENT, dispatchCustomEvent } from '@/helpers/customEvents'

export default {
  name: 'end',

  components: {
    TopHeader,
    ChatButton
  },

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  computed: {
    ...mapGetters('uistate', ['getBehavior', 'webView', 'isCustomerFlow']),
  },
  methods: {
    closeWindow (isRestart = false) {
      if (this.webView) {
        window.location.href += '?ChatBoxClosed=true'
      } else {
        trigger(triggerType.ACTION, 'ChatBoxClosed')
        if (this.getBehavior === 'passive' && !isRestart) {
          dispatchCustomEvent(EVENT.SEND.CLOSE)
        }
        this.$emit('close')
      }
      sessionStorage.behavior = ''
    },
    restartChat () {
      if (!this.webView) {
        this.closeWindow(true)
        this.$emit('open')
      }
      this.$store.dispatch('conversation/setArchived')
      if (this.webView) {
        location.reload()
      }
    },
    split1 (input) {
      if (input.split(' ', 2).length === 2) {
        return input.split(' ', 2)[0] + ' '
      } else if (input.split(/\b/).length === 2) {
        return input.split(/\b/)[0]
      } else {
        return input
      }
    },
    split2 (input) {
      if (input.split(' ', 2).length === 2) {
        return input.split(' ', 2)[1] + ' '
      } else if (input.split(/\b/).length === 2) {
        return input.split(/\b/)[1]
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.end {
  box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 3;
  background-color: #004435;
  color: white;
  border-radius: 0;

  &-layout {
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex-direction: row;

    .icon-container {
      text-align: center;
      margin-top: 25px;
      margin-bottom: 25px;
      > img {
        height: 60px;
        width: 60px;
      }
    }

    h1 {
      font-family: 'TheMix Bold', sans-serif;
      font-size: 40px;
      color: white;
      text-align: center;
      margin-bottom: 20px;
      span.alt-color {
        color: var(--tw-c-original-green);
      }
    }

    p.intro {
      color: white;
      font-size: 15px;
      line-height: 20px;
      text-align: center;
      padding: 0 15px;
    }

    .button-container {
      text-align: center;
      margin-top: 40px;
      padding: 0 15px;

      .button {
        height: 50px;
        width: 100%;
      }
    }
  }
  &-container {
    margin: auto;
  }
}
</style>
